import texts from './m60sVitalTexts.json'
import finnish from './m60sVitalTexts.fi.json'

export function m60sVitalText(locale, key, params = {}) {
    const lang = locale === 'pt-PTO' ? 'pt-PT' : locale
    const local = lang === 'fi-FI' ? { ...texts[lang], ...finnish } : texts[lang] || {}
    let text = Object.prototype.hasOwnProperty.call(local, key) ? local[key] : texts['en-US'][key]
    if (text === undefined) return key
    return String(text).replace(/\{(\w+)\}/g, (match, name) => params[name] === undefined ? match : String(params[name]))
}
